let config = {};
let ENV = "sznetsky";
switch (ENV) {
  case "morequick":
    config.title="智能物联 管理平台";
    config.pmsState=true;
    break;
  case "sznetsky":
    config.title="创E·智能物联 管理平台";
    config.pmsState=false;
    break;
  default:
    break;
}
// export default config;
module.exports =config